import React from 'react';
import axios from 'axios';
import {Table, Progress, Button, Select, Modal} from 'antd';
import env from './env.json';
import './assets/leaderboard.css';
import {LoadingOutlined} from "@ant-design/icons";

class Leaderboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMakePicksModalOpen: false,
            filteredSquad: 'All Squads'
        };
    }
    getLeaderboard = async () => {
        const resp = await axios.get(`${env.BACKEND_URL}/leaderboard`);
        if (resp && resp.data && resp.data.constants && resp.data.constants && resp.data.constants.hidePicks === 'TRUE') this.setState({hidePicks: true})
        if (resp && resp.data && resp.data.constants && resp.data.constants && resp.data.constants.hidePicks === 'FALSE') this.setState({hidePicks: false})
        if (this.state.filteredSquad !== 'All Squads') {
            resp.data.columns = resp.data.columns.filter(
                c => resp.data.squads[c.title] === this.state.filteredSquad || ['key', 'Answer'].includes(c.title)
            );
            resp.data.dataSource.forEach(row => {
                Object.keys(row).forEach(key => {
                    if (!['key', 'Answer'].includes(key) && resp.data.squads[key] !== this.state.filteredSquad) {
                        delete row[key];
                    }
                });
            });
            Object.keys(resp.data.names).forEach(name => {
                if (resp.data.squads[name] !== this.state.filteredSquad) {
                    delete resp.data.names[name];
                }
            });
        }
        return this.setState(resp.data);
    };
    componentDidMount = async () => {
        await this.getLeaderboard();
        this.interval = setInterval(async () => await this.getLeaderboard(), 1000);
    }
    componentWillUnmount() {clearInterval(this.interval);}

    getQuestionMetrics = () => {
        const {dataSource} = this.state;
        if (!dataSource) return {}
        let questionsAnswered = 0;
        let questionsUnanswered = 0;
        dataSource.forEach(d => {
            d.Answer === '-' ? questionsUnanswered += 1 : questionsAnswered += 1
        })
        const totalQuestions = questionsUnanswered + questionsAnswered;
        const percentage = questionsUnanswered / totalQuestions * 100;
        return {questionsUnanswered, questionsAnswered, totalQuestions, percentage}
    }
    getPoints = () => {
        const {dataSource, names} = this.state;
        if (!dataSource || !names) return {}
        const points = Object.assign({}, names);
        dataSource.forEach(d => {
            Object.keys(names).forEach(n => {
                if (d[n] === d['Answer'] || d['Answer'] === env.SKIPPED_STR) {
                    if (d['Answer'].includes('3pts')){
                        points[n] += 3
                    } else if (d['Answer'].includes('2pts')) {
                        points[n] += 2;
                    } else {
                        points[n] += 1;
                    }
                }
            })
        })
        return Object.entries(points).sort(([,a],[,b]) => b-a).reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
    }
    renderPoints = (points, questionMetrics) => {
        const data = [];
        for (const [n, p] of Object.entries(points)) {
            data.push(
                <div className='points-row' key={n}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}><span>{n}</span><span style={{color: '#970747', marginRight: 5}}>{p}</span></div>
                    <Progress percent={Math.round(p / questionMetrics.questionsAnswered * 100)} status={'normal'} strokeColor='#970747' showInfo={false}/>
                </div>

            )
        }
        return data;
    }
    colorColumns = (columns) => {
        const coloredColumns = Object.assign([], columns);
        coloredColumns.forEach(c => {
            c.render = (text, record, index) => {
                return {
                    props: {style: { background: record['Answer'] === '-' || text === record['key'] ? 'inherit' : (text === record['Answer'] || record['Answer'] === env.SKIPPED_STR)  ? "lightgreen" : "#e38ba9" }},
                    children: (this.state.hidePicks && text !== record['key']) ? <div>hidden</div> : <div>{text}</div>
                };
            }
        })
        return coloredColumns;
    }
    closeModal = () => {
        this.setState({isMakePicksModalOpen: false});
    }

    renderModal = () => {
        const {isMakePicksModalOpen} = this.state;
        if (isMakePicksModalOpen)  {
            return (
                <Modal className='make-picks-modal' open={isMakePicksModalOpen} onOk={() => this.closeModal()} onCancel={() => this.closeModal()} footer={null}>
                    <div className='picks-modal-content'>
                        <iframe
                            src={"https://docs.google.com/forms/d/e/1FAIpQLSco5j4GSushvpOzmwHTkuOGo_CYVTClW7HsKE3BF8ECKGhCPw/viewform?embedded=true"}
                            width="100%" height="100%" frameBorder="0" marginHeight="0" marginWidth="0">Loading…
                        </iframe>
                    </div>
                </Modal>
            )
        }
    }

    render() {
        const {dataSource, columns, names, hidePicks} = this.state;
        const questionMetrics = this.getQuestionMetrics();
        const points = this.getPoints();
        return (
            <React.Fragment>
                <div className='leaderboard-container'>
                    <div className='leaderboard-left-side'>
                        <Progress strokeColor='#970747' type="circle" percent={questionMetrics.percentage} format={() => <div>{questionMetrics.questionsUnanswered} <div>Left</div></div>}/>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                            <Button type="primary" className='make-your-picks-button' onClick={() => this.setState({isMakePicksModalOpen: true})}>Make Picks</Button>
                        </div>
                        <div className='score-container' style={{marginTop: 10}}>
                            {this.renderPoints(points, questionMetrics)}
                        </div>
                    </div>
                    <div className='leaderboard-right-side'>
                        {hidePicks && <div className='hide-responses'>Picks are hidden until kickoff</div>}
                        <Select
                            mode="single"
                            allowClear
                            style={{ width: '100%', marginBottom: 7}}
                            placeholder='Select Squad'
                            defaultValue={[{label: 'All Squads', value: 'All Squads'}]}
                            onChange={(squad) => this.setState({filteredSquad: squad})}
                            options={names ? [{label: 'All Squads', value: 'All Squads'}, {label: 'Jay', value: 'Jay'}, {label: 'Chirag & Steph', value: 'Chirag & Steph'}]: []}
                        />
                        <Table
                            dataSource={dataSource}
                            columns={this.colorColumns(columns)}
                            pagination={false}
                            scroll={{ y: '100vh' }}
                            locale={{
                                emptyText: (
                                    <div>
                                        <LoadingOutlined style={{ fontSize: 50, marginBottom: 10 }} />
                                        <div>This may take a few seconds...</div>
                                    </div>
                                ),
                            }}
                        />
                    </div>
                    {this.renderModal()}
                </div>
            </React.Fragment>
        );
    }

}

export default Leaderboard;